import React, { useState } from 'react';
import { shape, string, func, bool } from 'prop-types';
import { NamedLink, PrimaryButton } from '../../components';
import DetailCardImage from '../TransactionPanel/DetailCardImage';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { formatMoney } from '../../util/currency';
import Modal from '../Modal/Modal';
import config from '../../config';
import css from './MessageMobilePanel.css';

const MessageMobilePanel = props => {
  const { listing, otherUser, currentUser, intl, onPurchase, onManageDisableScrolling } = props;

  const [customPrice, setCustomPrice] = useState('');
  const [minAmountError, setMinAmountError] = useState(false);
  const [offerInProgress, setOfferInProgress] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const min = config.minimumOffer;

  const handleOfferSubmit = () => {
    setMinAmountError(false);
    const priceToSent = customPrice !== '' ? customPrice : listing.attributes.price.amount / 100;

    if (customPrice < min) {
      setMinAmountError(true);
      setOfferInProgress(false);
    } else {
      setOfferInProgress(true);
      onPurchase(listing, { price: priceToSent / (listing.attributes.price.amount / 100) });
      setIsModalOpen(false);
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const listingTitle = listing?.attributes?.title;
  const firstImage = listing?.images?.[0];
  const price = listing?.attributes?.price;

  const formattedPrice = price ? formatMoney(intl, price) : '';
  
  const isClosed = listing.attributes.publicData.available !== 'Disponible';
  const isSold = listing.attributes.publicData.sold;
  const isOwnListing = listing.author.id.uuid === currentUser.id.uuid;

  return (
    <div className={css.mobileHeaderMainContainer}>
      <div className={css.mobileHeaderFlex}>
        <div className={css.mobileHeaderUpperContainer}>
          <div className={css.mobileImage}>
            <NamedLink name="ListingPageCanonical" params={{ id: listing.id.uuid }}>
              <ResponsiveImage
                rootClassName={css.imageWrapperMobile}
                listingTitle={listingTitle}
                image={firstImage}
                variants={['square-small']}
                provider={listing?.author}
                isCustomer={false}
              />
            </NamedLink>
          </div>
          <div className={css.mobileHeader}>
            <NamedLink name="ListingPageCanonical" params={{ id: listing.id.uuid }}>
              <p className={css.mobileTitle}><b>{listingTitle}</b></p>
            </NamedLink>
            <div>
              <div className={css.mobilePrice}>{formattedPrice}</div>
              {/* <div className={css.buttonMobileContainer}>
                <div className={css.buttonWrapper}>
                  {!isClosed && !isSold && !isOwnListing && (
                    <>
                      <button className={css.offerButtonMobile} onClick={openModal}>
                        Hacer Oferta
                      </button>
                      <button className={css.purchaseButtonMobile} onClick={() => onPurchase(listing, { price: 1 })}>
                        Comprar
                      </button>
                    </>
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className={css.infoMessage}>
        <span className={css.infoIcon}>🔒</span>
        Recuerda que tus compras dentro de Gloset están protegidas y tienen garantía
      </div>

      {/* Offer Modal */}
      <Modal
        id="OfferModalMobile"
        isOpen={isModalOpen}
        onClose={closeModal}
        usePortal
        contentClassName={css.modalContent}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div>
          <h2 className={css.title}>Haz una oferta</h2>
          <input
            type="number"
            value={customPrice}
            onChange={e => setCustomPrice(e.target.value)}
            placeholder="Ingresa una cantidad a ofertar"
            min={min}
            className={css.offerInput}
          />
          <PrimaryButton className={css.buyButton} onClick={handleOfferSubmit} disabled={offerInProgress}>
            Enviar Oferta
          </PrimaryButton>
          {minAmountError && <p className={css.error}>El mínimo precio que se puede ofertar es de ${Number(min).toFixed(2)} MXN</p>}
        </div>
      </Modal>
    </div>
  );
};

MessageMobilePanel.propTypes = {
  listing: shape({
    id: shape({
      uuid: string.isRequired,
    }).isRequired,
    attributes: shape({
      title: string.isRequired,
      price: shape({
        amount: string.isRequired,
        currency: string.isRequired,
      }),
      publicData: shape({
        available: string,
        sold: bool,
      }),
    }).isRequired,
    author: shape({
      id: shape({
        uuid: string.isRequired,
      }),
    }).isRequired,
    images: shape({
      attributes: shape({
        variants: shape({
          default: shape({
            url: string,
          }),
        }),
      }),
    }),
  }).isRequired,
  otherUser: shape({
    id: string.isRequired,
    attributes: shape({
      profile: shape({
        displayName: string.isRequired,
      }),
    }),
  }).isRequired,
  currentUser: shape({
    id: shape({
      uuid: string.isRequired,
    }).isRequired,
  }).isRequired,
  intl: shape({
    formatMessage: func.isRequired,
  }).isRequired,
  onPurchase: func.isRequired,
  onManageDisableScrolling: func.isRequired,
};

export default MessageMobilePanel; 